module.exports = __webpack_public_path__ + "static/media/catalogo.6a7c34b0.svg";